import { useQuery } from "@tanstack/react-query";
import { useAuth } from "contexts/auth";
import { getInsightsEnabled } from "v2/services/insights.service";

export function useInsightsEnabled() {
  const { user } = useAuth();
  const organizationId = user?.organization?.id;

  const { data, isLoading } = useQuery({
    queryKey: ["insights-enabled", organizationId],
    queryFn: () => getInsightsEnabled(organizationId as string),
    enabled: !!organizationId,
    retry: false,
    staleTime: 5 * 60 * 1000,
  });

  return {
    enabled: data?.enabled === true,
    qualifyingBuyerIds: data?.qualifyingBuyerIds ?? [],
    isLoading,
  };
}
